import { render, staticRenderFns } from "./GooglePay.vue?vue&type=template&id=648c5966&"
import script from "./GooglePay.vue?vue&type=script&lang=js&"
export * from "./GooglePay.vue?vue&type=script&lang=js&"
import style0 from "./GooglePay.vue?vue&type=style&index=0&id=648c5966&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports